export const Work = [
    {
        id:1,
        name:"Stack Overflow Clone",
        description:"This is my first website, which I have created by cloning stackOverflow.",
        tags:["HTML","CSS","JavaScript"],
        
        demo:"https://github.com/SEEMANTULANISCHAL/stack-overflow-clone.git",
        github:"https://github.com/SEEMANTULANISCHAL/stack-overflow-clone.git"
    },
    {
        id:2,
        name:"Disaster Prediction using Machine Learning",
        description:"I have trained my system on a number of disasters so that every calamity that occurs in the future can be predicted.",
        tags:["Pandas","Scikit-Learn", "NumPy"],
        
        demo:"https://github.com/SEEMANTULANISCHAL/Disaster-Prediction-using-ML.git",
        github:"https://github.com/SEEMANTULANISCHAL/Disaster-Prediction-using-ML.git"
        
    },
    {
        id:3,
        name:"Learn 4 Growth",
        description:"Learn4Growth is a collaborative learning application developed to address the challenges that students have when seeking solutions to their queries.",
        tags:["Java","XML","PHP"],
        
        demo:"https://github.com/SEEMANTULANISCHAL/Learn4Growth_Android_Application.git",
        github:"https://github.com/SEEMANTULANISCHAL/Learn4Growth_Android_Application.git"
    },
    {
        id:4,
        name:"Mr. Doctor Application",
        description:"A cool looking website incorporated with python tkinker model to predict disease of a patient.",
        tags:["HTML","JavaScript","tkinker"],
        
        demo:"https://seemantulanischal.github.io/MR.DOCTOR-APPLICATION/",
        github:"https://github.com/SEEMANTULANISCHAL/MR.DOCTOR-APPLICATION.git"
       
    },{
        id:5,
        name:"AgroMart",
        description:"Developed an e-commerece website to create bridge between the consumers and farmers.",
        tags:["react","Node","Mongo"],
        
        demo:"https://github.com/SEEMANTULANISCHAL/AgroMart-Final.git",
        github:"https://github.com/SEEMANTULANISCHAL/AgroMart-Final.git"
        
    },
    {
        id:6,
        name:"System Monitoring Employee Management",
        description:"A software that I have developed for the Larsen and Toubro company  which empowers administrators to effectively track employees' activities.",
        tags:["C#","Visual Studio","SQL"],
        
        demo:"https://github.com/SEEMANTULANISCHAL/System_Monitoring_Employee_Management.git",
        github:"https://github.com/SEEMANTULANISCHAL/System_Monitoring_Employee_Management.git"
        
    },
    
  
] 